"use client"

import { useEffect, useState } from "react"
import BetslipItem from "./BetslipItem"
import FriendsList from "./FriendsList"

function Betslip({ selectedBet }) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showBetSlip, setShowBetslip] = useState(true)
  const empty = !selectedBet

  /* const handleSummaryClick = () => {
    if (!empty) {
      setIsModalOpen(true)
    }
  } */

  useEffect(() => {
    if (!empty) {
      setIsModalOpen(true)
    }
  }, [selectedBet])

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div className="relative flex flex-col min-h-full bg-gray-900/80 backdrop-blur-sm rounded-xl border border-gray-800">
      <div className="flex justify-center mb-4 pt-3">
        <div className="inline-block rounded-full bg-gray-800/70 p-1">
          <div className="inline-flex rounded-full overflow-hidden">
            <button
              onClick={() => {
                setShowBetslip(true)
              }}
              className={`px-4 py-1.5 text-xs font-medium transition-colors duration-200 
                ${showBetSlip ? "bg-emerald-500 text-white" : "bg-transparent text-gray-300 hover:text-white"}`}
            >
              Betslip
            </button>
            <button
              onClick={() => {
                setShowBetslip(false)
              }}
              className={`px-4 py-1.5 text-xs font-medium transition-colors duration-200 
                ${!showBetSlip ? "bg-emerald-500 text-white" : "bg-transparent text-gray-300 hover:text-white"}`}
            >
              Friends
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      {showBetSlip && (
        <div className="w-full min-h-[50vh] flex flex-col px-3 xl:px-4">
          <div className="flex justify-between items-center mb-3">
            <h1 className="text-white text-base font-semibold">Betslip</h1>
          </div>
          <div className="flex flex-grow items-center justify-center text-white">
            {empty && (
              <div className="text-center py-12">
                <div className="bg-gray-800/70 p-4 rounded-xl inline-block mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-gray-500 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <h2 className="text-base font-medium mb-2">Betslip Empty</h2>
                <p className="text-gray-400 text-sm">Select an event to place a bet</p>
              </div>
            )}
            {!empty && (
              <div className="hidden sm:flex flex-col w-full">
                <BetslipItem bet={selectedBet} />
              </div>
            )}
          </div>
        </div>
      )}

      {!showBetSlip && (
        <div className="mx-5">
          <FriendsList />
        </div>
      )}
    </div>
  )
}

export default Betslip

